import React, { useRef } from 'react';
import { MdBugReport } from 'react-icons/md';
import { CreateEditTestIssue } from '@/pages/testIssue/CreateEditTestIssue';
import { Drawer, DrawerRef } from '@/components/shared/panel/Drawer';
import { IDetailTestRunSchema } from '@/api/testRunDetail';
import { Button } from 'alurkerja-ui';

type AddIssueProps = {
  testRunDetail: IDetailTestRunSchema;
  onSuccess?: () => void;
};

const AddIssue: React.FC<AddIssueProps> = ({ testRunDetail, onSuccess }) => {
  const ref = useRef<DrawerRef>(null);

  return (
    <>
      <Button
        type="button"
        className="mx-0.5 bg-orange-600"
        onClick={() => ref.current?.open()}
      >
        <MdBugReport size={20} />
      </Button>

      <Drawer ref={ref}>
        <CreateEditTestIssue
          backAction={() => {
            ref.current?.close();
          }}
          onSuccess={() => {
            onSuccess?.();
            ref.current?.close();
          }}
          testRunDetail={testRunDetail}
        />
      </Drawer>
    </>
  );
};

export default AddIssue;
